import { render, staticRenderFns } from "./AddDispatch.vue?vue&type=template&id=29269efe&scoped=true"
import script from "./AddDispatch.vue?vue&type=script&lang=js"
export * from "./AddDispatch.vue?vue&type=script&lang=js"
import style0 from "./AddDispatch.vue?vue&type=style&index=0&id=29269efe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29269efe",
  null
  
)

export default component.exports